import React, { useRef, useState } from 'react'
import { Form } from 'react-bootstrap'
import Select, { components } from 'react-select'
import { getIn, setIn } from 'formik'
import { DropdownIndicator, MultiValueContainer } from './FormSelectComponents'
import { countries } from '../constants/CountryList'
import _ from 'lodash'
const { Control, Group, Label, Image } = Form
export default function FormSelectCountry({
  field,
  form: {
    touched = {},
    errors = {},
    setFieldValue = () => {},
    setTouched = () => {},
  } = {},
  icon,
  options = countries,
  handleChange,
  isMulti = false,
  // showSelectAll = false,
  isSearchable = true,
  disabled = false,
  hideSelectedOptions,
  ...props
}) {
  const showError = !!getIn(touched, field.name) && !!getIn(errors, field.name)
  const wrapperRef = useRef(null)
  const selectRef = useRef(null)
  const [selectedValue, setSelectedValue] = useState(null)
  const [menuState, setMenuState] = useState(false)
  const onChange = value => {
    setFieldValue(field.name, value)
    if (handleChange && value) {
      setSelectedValue(null)
      handleChange(value)
    }
  }

  const onBlur = event => {
    if (!field.value) {
      setFieldValue(field.name, selectedValue)
      if (
        handleChange &&
        selectedValue &&
        !selectRef.current.state.menuIsOpen
      ) {
        handleChange(selectedValue)
      } else {
        setMenuState(true)
      }
    }
    const _touched = setIn({ ...touched }, field.name, true)
    setTouched(_touched)
  }

  const MenuList = props => {
    return (
      <components.MenuList {...props}>
        <div
          className=' scrollable-page-content'
          style={{ maxHeight: '250px', height: 'auto' }}
        >
          {props.children}
        </div>
      </components.MenuList>
    )
  }
  const Option = props => {
    return (
      <div className='selectOptionButton  ScrollbarsCustom-Thumb ScrollbarsCustom-ThumbY'>
        <components.Option {...props}>
          <div className='d-flex align-items-center'>
            <span>{`${props.data.label}`}</span>
          </div>
        </components.Option>
      </div>
    )
  }
  const ValueContainerSearch = ({ children, ...props }) => {
    if (children) {
      if (props.selectProps.menuIsOpen && props.hasValue) {
        if (selectRef && selectRef.current) {
          selectRef.current.select.focus()
        }
      }
    }
    return (
      components.ValueContainer && (
        <components.ValueContainer {...props}>
          {!!children && !props.hasValue && (
            <img
              className='pb-1 pr-1 mr-1'
              style={{ width: '18px' }}
              src={
                props.hasValue
                  ? `/images/icons/Icon_Search_Active.png`
                  : `/images/icons/Icon_Search_Inactive.png`
              }
              alt=''
            />
          )}
          {children}
        </components.ValueContainer>
      )
    )
  }

  const ValueContainer = isMulti ? MultiValueContainer : ValueContainerSearch

  const onMenuOpen = (ref, evt) => {
    if (
      ref.current.select &&
      ref.current.select.commonProps &&
      ref.current.select.commonProps.hasValue
    ) {
      setSelectedValue(ref.current.props.value)
      ref.current.select.clearValue()
      setMenuState(true)
      var continueBtns = document.getElementsByClassName(
        'react-currencySelect__value-container'
      )
      continueBtns[0].classList.add(
        'react-currencySelect__value-container-hide'
      )
    }
  }
  return (
    <Group controlId={field.name} ref={wrapperRef}>
      <div style={{ borderBlockColor: 'red' }}>
        <Label className='form-label'>{props.label}</Label>
        <Select
          components={{ DropdownIndicator, ValueContainer, Option, MenuList }}
          className={`react-countrySelect-container ${
            showError ? 'is-invalid' : ''
          }`}
          classNamePrefix='react-currencySelect'
          placeholder={<div className={'pl-4'}>Choose country...</div>}
          hideSelectedOptions={
            hideSelectedOptions !== undefined ? !!hideSelectedOptions : !isMulti
          }
          {...field}
          ref={selectRef}
          inputId={field.name}
          onBlur={e => onBlur(e)}
          blurInputOnSelect={false}
          onChange={e => onChange(e)}
          // openMenuOnFocus={true}
          onMenuOpen={evt => {
            onMenuOpen(selectRef, evt)
          }}
          onMenuClose={() => {
            setMenuState(false)
            var continueBtns = document.getElementsByClassName(
              'react-currencySelect__value-container'
            )
            continueBtns[0].classList.remove(
              'react-currencySelect__value-container-hide'
            )
          }}
          options={options}
          getOptionLabel={option => {
            return (
              <div className='selectOptionButtonCurrency'>
                <div className='d-flex align-items-center'>
                  <span>{`${option.label}`}</span>
                </div>
              </div>
            )
          }}
          isSearchable={isSearchable}
          isDisabled={disabled}
          // menuIsOpen={true}
        />
      </div>
      {showError && (
        <Control.Feedback className='d-block' type='invalid'>
          {getIn(errors, field.name)}
        </Control.Feedback>
      )}
    </Group>
  )
}
